"use strict";

let sentryClient = null;

const loadSentry = async () => {
    if (sentryClient) return sentryClient;

    const mod = await import("@sentry/browser");
    sentryClient = mod;
    return mod;
};

export const prettyPrintJson = function(json) {
    return JSON.stringify(json, null, 2)
}

export const sentryFlag = process.env.ENABLE_SENTRY == "true";

export const initSentry = function() {
    console.log('Sentry:' + exports.sentryFlag)
    if (exports.sentryFlag) {
        loadSentry()
            .then((Sentry) => {
                Sentry.init({
                    dsn: process.env.SENTRY_DSN,
                    environment: process.env.SENTRY_ENVIRONMENT,
                })
                console.log('Initialized Sentry')
            })
            .catch((err) => {
                console.error("Failed to initialize Sentry", err)
            })
    }
}

export const captureError = function(err) {
    return function() {
        var errId = ""
        console.log('Error: ' + err.toString())
        if (exports.sentryFlag) {
            if (sentryClient && typeof sentryClient.captureMessage === "function") {
                errId = sentryClient.captureMessage(err.message, {
                    contexts: err.contexts
                })
                console.log('Reported to Sentry')
            } else {
                console.warn("Sentry is enabled but not initialized")
            }
        }
        return errId
    }
}

export const reloadPage = function() {
    console.log("Reloading")
    window.location.reload()
}
